import type { State } from 'store/types'

export const selectIsListDetailsOpen = (state: State) => state.isListDetailsOpen
